module.exports = __webpack_public_path__ + "static/media/protecao-smartwatch_new.360d3658.svg";